import { createTheme, adaptV4Theme } from "@mui/material";
import {
  CUSTOM_BREAKPOINT_VALUES,
  responsiveFontSize,
} from "style/style_snippets"

const customMUITheme = createTheme(adaptV4Theme({
  breakpoints: {
    values: CUSTOM_BREAKPOINT_VALUES,
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#00adef",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      // light: will be calculated from palette.primary.main,
      main: "#ffffff",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: "none",
        borderRadius: 0,
        fontSize: responsiveFontSize(14, 16),
        fontWeight: 400,
      },
      containedPrimary: {
        color: "white",
      },
    },
  },
  typography: {
    fontFamily: "'MBCorpoSText', georgia, serif",
    h1: {
      fontWeight: 600,
      fontSize: responsiveFontSize(25, 48),
      letterSpacing: 0,
    },
    h2: {
      fontSize: responsiveFontSize(22, 34),
      fontWeight: 600,
      letterSpacing: 0.26,
    },
    h3: {
      fontSize: responsiveFontSize(20, 28),
      fontWeight: 600,
      letterSpacing: 0.21,
    },
    h4: {
      fontSize: responsiveFontSize(18, 20),
      textAlign: "left",
      margin: 0,
      letterSpacing: 0.21,
    },
    body1: {
      fontSize: responsiveFontSize(14, 16),
      textAlign: "left",
      margin: 0,
      letterSpacing: 0.23,
    },
    overline: {
      fontSize: responsiveFontSize(14, 16),
      letterSpacing: 0.65,
      textTransform: "none",
      lineHeight: "inherit",
    },

    allVariants: {
      color: "#333333",
    },
  },
}))

export default customMUITheme
